import { render, staticRenderFns } from "./UserAdmin.vue?vue&type=template&id=8fc7438c"
import script from "./UserAdmin.vue?vue&type=script&lang=js"
export * from "./UserAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fc7438c')) {
      api.createRecord('8fc7438c', component.options)
    } else {
      api.reload('8fc7438c', component.options)
    }
    module.hot.accept("./UserAdmin.vue?vue&type=template&id=8fc7438c", function () {
      api.rerender('8fc7438c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/UserAdmin.vue"
export default component.exports